document.addEventListener("DOMContentLoaded", () => {
    // define live-site url
    let liveSites = document.querySelectorAll('a[href*="live-alliance-for-a-healthy-kansas-2022.pantheonsite.io"]');

    // if live-site url is true,
    if (liveSites) {
        [].forEach.call(liveSites, (anchor) => {
            replaceUrlInPermalink(anchor);
        });
    };

    //.. then replace with relative path
    function replaceUrlInPermalink(anchor) {
        const removeThis = 'live-alliance-for-a-healthy-kansas-2022.pantheonsite.io';
        let href = anchor.href;
        let splitUp = href.split(`${removeThis}`);
        let newHref = splitUp[1];
        if (newHref) {
            anchor.href = newHref;
        };
    };

});